import React from "react";
import { PageNotFound } from "components/page-not-found";

export const PageNotFoundContainer = () => (
  <PageNotFound />
);



// WEBPACK FOOTER //
// ./src/js/containers/page-not-found-container.jsx